import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _this = this;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import moment from 'moment';
import { createHashHistory } from 'history';
import * as ajax from './ajax';
import contentChangeActionFactory from './factories/contentChangeActionFactory';
import entityActionFactory from './factories/entityActionFactory';
import reportConstants from '../constants/reportConstants';
import tokenErrorActions from './tokenErrorActionCreators';
import uploadActionFactory from './factories/uploadActionFactory';
import notificationActions from './notificationActionCreators';
const entityActions = entityActionFactory('report', 'reports');
const contentChangeActions = contentChangeActionFactory('report', 'reports');
const uploadActions = uploadActionFactory('report', 'reports', true, 'Photo');
const hashHistory = createHashHistory();
const handleRedirect = (dispatch, getState) => {
  const entityState = getState().report;
  dispatch(entityActions.serverIndex(entityState.indexQuery, true, true));
  if (hashHistory.location.pathname.includes('reportDocuments')) {
    // If within the report document view, just go back to the report.
    hashHistory.goBack();
  } else {
    hashHistory.push('/file-cabinet');
  }
};
const serverShow = function serverShow(id) {
  let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let successFunc = arguments.length > 2 ? arguments[2] : undefined;
  let failureFunc = arguments.length > 3 ? arguments[3] : undefined;
  return contentChangeActions.serverShow(id, query, successFunc, failureFunc, handleRedirect);
};

/**
   *  Create a report. Add an id to the mergePatch and use normal save. Allow
   *  an id to be passed to enable testing.
   */
const create = (id, createdDate, geolocation, jobID, reportType) => {
  const reportTypeID = reportType.id,
    version = reportType.version;
  const createdLatitude = geolocation.latitude;
  const createdLongitude = geolocation.longitude;
  const mergePatch = {
    id,
    patch: {
      createdLatitude,
      createdLongitude,
      jobID,
      reportTypeID,
      _created: createdDate,
      version
    }
  };
  return contentChangeActions.serverSaveMergePatches(id, [mergePatch], (reportid, response) => {
    let data = response;
    if (Array.isArray(response)) {
      var _response = _slicedToArray(response, 1);
      data = _response[0];
    }
    return contentChangeActions.createSuccess(reportid, data);
  });
};
const saveAssignmentsSuccess = id => dispatch => {
  dispatch(notificationActions.success({
    message: 'Successfully applied assignment changes.',
    id
  }));
};
const saveAssignmentsFailure = (id, _ref) => {
  let message = _ref.message;
  return dispatch => {
    dispatch(notificationActions.error({
      message,
      id
    }));
  };
};
const serverSaveAssignments = (id, assignments) => async dispatch => {
  try {
    await ajax.post('/reports/assignments', assignments);
    dispatch(entityActions.selectClearAll());
    return dispatch(saveAssignmentsSuccess(id));
  } catch (e) {
    return dispatch(tokenErrorActions.handleError(e, 'report', saveAssignmentsFailure.bind(this, id, e), serverSaveAssignments.bind(this, id, assignments), handleRedirect));
  }
};

/**
 * Override the base saveAllSuccess in changeActionFactory
 * so we can dispatch an additional index event.
 * @param {Object} data - Updated data after saveSuccess
 */
const saveAllSuccess = data => (dispatch, getState) => {
  const _getState = getState(),
    report = _getState.report;
  dispatch(contentChangeActions.saveAllSuccess(data));
  return dispatch(entityActions.serverIndex(report.indexQuery, false));
};
const render = () => ({
  type: reportConstants.RENDER
});

// This could be a show success, however show success performs extra state
// changes, all renderSuccess need do is replace the active entity with the
// new one returned from the server
const renderSuccess = data => ({
  type: reportConstants.RENDER_SUCCESS,
  data
});
const renderFailure = reportID => ({
  type: reportConstants.RENDER_FAILURE,
  reportID
});
const serverRenderReport = reportID => async (dispatch, getState) => {
  const url = "/reports/render/".concat(reportID);
  dispatch(render());
  try {
    const response = await ajax.get(url);
    return dispatch(renderSuccess(response.data));
  } catch (e) {
    const failureAction = () => {
      // must check for error response, internal and network errors have no 'response'
      if (e.response && e.response.status === 410) {
        // 410 === 'Report Not Found' / GoneError
        const _getState2 = getState(),
          report = _getState2.report;
        // re-fetch reports since the requested report has been deleted and may still be visible
        // in the file cabinet: https://www.pivotaltracker.com/story/show/160912438
        dispatch(entityActions.serverIndex(report.indexQuery, true, true));
      }
      return dispatch(renderFailure(reportID));
    };
    return dispatch(tokenErrorActions.handleError(e, 'report', failureAction, serverRenderReport.bind(this, reportID), handleRedirect));
  }
};
const _serverSaveStatusUpdates = function serverSaveStatusUpdates(reports, statusName) {
  let info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let geolocation = arguments.length > 3 ? arguments[3] : undefined;
  return async dispatch => {
    const changedReports = reports.map(currentReport => {
      const changedReport = {
        id: currentReport.id
      };
      changedReport.statusName = statusName;
      changedReport.statusDate = moment.utc().format('YYYY-MM-DD HH:mm:ss');
      changedReport.latitude = geolocation.latitude;
      changedReport.longitude = geolocation.longitude;
      if (statusName === 'Rejected') {
        changedReport.note = info.note;
      } else if (statusName === 'Approved') {
        if (info.nextInspection) {
          // to match the iPad use the current timestamp for the time portion of the
          // selected date. dateTimePicker returns midnight plus the timezone offset
          // instead of a timestamp.
          const now = moment();
          const nextInspectionTimestamp = moment(info.nextInspection).set({
            hour: now.hour(),
            minute: now.minute(),
            second: now.second()
          });
          changedReport.nextInspection = nextInspectionTimestamp.toISOString();
        }
        if (typeof info.signaturePath === 'string' && info.signaturePath.length) {
          changedReport.signaturePath = info.signaturePath;
        }
        changedReport.note = info.note;
      }
      return changedReport;
    });
    try {
      const response = await ajax.post('/reports/status', changedReports);
      dispatch(contentChangeActions.saveAllSuccess(response.data));
    } catch (e) {
      dispatch(tokenErrorActions.handleError(e, 'report', contentChangeActions.saveAllFail.bind(_this, e), _serverSaveStatusUpdates.bind(_this, reports, statusName, info, geolocation), handleRedirect));
    }
    return contentChangeActions.saveAll();
  };
};

/**
 * Undelete reports - restores metaDeleted flag on reports and related tables
 */
const serverUndeleteReports = ids => async (dispatch, getState) => {
  try {
    await ajax.post('/reports/undelete', {
      ids
    });
    const _getState3 = getState(),
      report = _getState3.report;
    dispatch(entityActions.selectClearAll());
    return dispatch(entityActions.serverIndex(report.indexQuery, true, true));
  } catch (e) {
    return dispatch(tokenErrorActions.handleError(e, 'report', contentChangeActions.saveAllFail.bind(this, e), serverUndeleteReports.bind(this, ids), handleRedirect));
  }
};
const reportActions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, entityActions), uploadActions), contentChangeActions), {}, {
  serverSaveAssignments,
  create,
  render,
  renderSuccess,
  renderFailure,
  saveAllSuccess,
  serverSaveStatusUpdates: _serverSaveStatusUpdates,
  serverShow,
  serverRenderReport,
  serverUndeleteReports
});
export default reportActions;